document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".capsule-auth__body");
  if (!root) return;

  const form = root.querySelector("form");
  if (!form) return;

  // Cherche des "rows" de champs (apps souvent différentes)
  const rows = form.querySelectorAll(
    "[data-field], .field, .form-field, .amplius-field, .amplius_customer_fields__field, .input-group, .customer-fields-field"
  );

  // Si on ne détecte pas, on ne casse rien
  if (!rows.length) return;

  // Met tout en full width par défaut
  rows.forEach(r => r.classList.add("capsule-full"));

  // Helpers: détecte par le texte du label
  const findByLabelIncludes = (includesArr) => {
    const arr = Array.from(rows);
    return arr.find(r => {
      const t = (r.querySelector("label")?.textContent || "").trim().toLowerCase();
      return includesArr.some(k => t.includes(k));
    });
  };

  // On veut: Prénom + Nom en 2 colonnes
  const first = findByLabelIncludes(["prénom", "first"]);
  const last  = findByLabelIncludes(["nom", "last"]);

  if (first) first.classList.remove("capsule-full");
  if (last)  last.classList.remove("capsule-full");

  // Submit full width (au cas où)
  const submit = form.querySelector('button[type="submit"], input[type="submit"]');
  if (submit) submit.classList.add("capsule-full");
});